export function validateName(namesUrl, nameInput) {
    // Variables
    let names = [];

    // Define a class for reactive variables
    class ReactiveVariable {
        constructor(value) {
            this.value = value;
            this.observers = [];
        }

        // Method to set the value of the reactive variable
        setValue(newValue) {
            this.value = newValue;
            this.notifyObservers();
        }

        // Method to add an observer to the reactive variable
        addObserver(observer) {
            this.observers.push(observer);
        }

        // Method to notify all observers when the value changes
        notifyObservers() {
            this.observers.forEach(observer => {
                observer(this.value);
            });
        }
    }

    // Example usage:
    const error = new ReactiveVariable(false); // Initialize error as false

    // Function to display or hide error message based on error value
    function updateErrorMessage(displayError) {
        const errorMessage = document.getElementById('error-message-name');
        errorMessage.style.display = displayError ? 'flex' : 'none';
        if (displayError) {
            nameInput.classList.add('form__input--error');
        } else {
            nameInput.classList.remove('form__input--error')
        }
    }

    // Add observer to the error variable
    error.addObserver((value) => {
        const isValid = !value;
        // Update submit button based on error value
        updateErrorMessage(value);
        const nameValidityEvent = new CustomEvent('nameValidity', {
            detail: { isValid }
        });

        document.dispatchEvent(nameValidityEvent);
    });


    function ngOnInit() {
        getNames();
        // Add event listeners to listen for input changes
        listenToNameValueChanges();
    }

    function listenToNameValueChanges() {
        // Add an event listener to the input field for the 'keydown' event
        nameInput.addEventListener('keydown', function (event) {
            // Get the keycode of the pressed key
            const keyCode = event.keyCode || event.which;

            // Allow certain keycodes (e.g., backspace, delete, arrow keys)
            if ((keyCode >= 65 && keyCode <= 90) || // Letters
                (keyCode >= 97 && keyCode <= 122) || // Letters
                keyCode === 8 || // Backspace
                keyCode === 46 || // Delete
                (keyCode >= 37 && keyCode <= 40)) { // Arrow keys
                return true; // Allow the keypress
            } else if (keyCode === 9 || keyCode === 13) {
                setTimeout(() => {
                    // Call the checkName function with the current value of the input field
                    checkName(nameInput.value); //wait for input value to change
                }, 100);
            } else {
                event.preventDefault(); // Prevent the keypress
                return false;
            }
        });

        nameInput.addEventListener('input', function (event) {
            // Subscribe to the observable and handle the value changes
            let value = event.target.value;
            value = value.replace(/\s+/g, '');
            value = value.replace(/\d+/g, '');
            value = value.toUpperCase();
            event.target.value = value;

            checkName(value);
        });

        nameInput.addEventListener('change', function (event) {
            const enteredName = event.target.value;
            checkName(enteredName);
        })
    }

    function checkName(data) {
        const name = data.toLowerCase();
        const nameExist = names.filter(x => x.toLowerCase() === name).length > 0;

        error.setValue(!!(!nameExist && data));
    }

    function getNames() {
        fetch(namesUrl)
            .then(response => {
                // Check if the request was successful (status code 200 OK)
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                // Parse the response body as JSON
                return response.json();
            })
            .then(responseData => {
                names = responseData.data.names;
                $('#lp-form-name').suggest(names, {
                    // Available options with defaults:
                    suggestionColor: '#cccccc',
                    moreIndicatorClass: 'suggest-more',
                    moreIndicatorText: '&hellip;'
                });
            })
            .catch(error => {
                // Handle errors during the fetch
                console.error('Fetch error:', error);
            });
    }

    /**
     * Execute functions
     */
    ngOnInit();
}
